export default __webpack_public_path__ + "static/media/chart.fb1fd40b.svg";